module.exports = __webpack_public_path__ + "media/images/lb/667-323364611439d0c2098885d50226612a.svg";